// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { wishListCardStyles } from "@sc/Overrides/Components/WishListCard";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import AddListToCart from "@sc/XDL/Icons/AddListToCart";
import DeleteXList from "@sc/XDL/Icons/DeleteXList";
import HideList from "@sc/XDL/Icons/HideList";
import StarX from "@sc/XDL/Icons/StarX";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

wishListCardStyles.wishListInfoGridItem = {
    width: 12,
};

wishListCardStyles.basicInfoGridItem = {
    width: 12,
};

wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        & > ${StyledButton} {
            font-weight: bold;
        }

        ${TypographyStyle} {
            font-size: 16px;
        }
    `,
};

wishListCardStyles.extendedInfoGridItem = {
    width: [12, 12, 7, 6, 6],
    align: "middle",
    css: css`
        align-items: center;
    `,
};

wishListCardStyles.sharingStatusGridItem = {
    width: 12,
    css: css`
        align-items: center;
        font-size: 12px;
        line-height: 13px;
        gap: 20px;
        ${xScreen("lte", "md")} {
            justify-content: flex-start;
        }
    `,
};

wishListCardStyles.actionGridMediumHidden = {
    css: css`
        width: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

wishListCardStyles.productImage = {
    width: "92px",
    height: "92px",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 72px;
            height: 72px;
        }
        img {
            height: auto;
            max-height: 100%;
            max-width: 100%;
        }
    `,
    errorTypographyProps: {
        size: 11,
        css: css`
            max-height: 65px;
        `,
    },
};

wishListCardStyles.productImagesGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 21px;

        ${xScreen("lte", "md")} {
            &:empty {
                display: none;
            }
        }

        ${xScreen("lte", "sm")} {
            padding: 13px 15px 10px;
        }
    `,
};

wishListCardStyles.lastUpdatedText = {
    size: 12,
    lineHeight: "14px",
    css: css`
        ${xScreen("gte", "md")} {
            min-height: 28px;
        }
    `,
};

wishListCardStyles.actionGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding-top: 12px;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 12px;
            right: 12px;
            height: 1px;
            background-color: ${color("common.border")};
        }
    `,
};

wishListCardStyles.productImageLink = {
    css: css`
        margin: 0;
    `,
    typographyProps: {
        css: css`
            display: flex;
        `,
    },
};

wishListCardStyles.actionAddToCartLink = {
    ...createLinkIconStyles(AddListToCart, {
        css: css`
            margin-right: auto;
        `,
    }),
};

wishListCardStyles.viwListLink = {
    ...createLinkIconStyles("", {
        css: css`
            margin-right: auto;
        `,
    }),
};

wishListCardStyles.actionDeleteLink = {
    ...createLinkIconStyles(DeleteXList, {
        css: css`
            border-left: 1px solid ${color("common.border")};
            padding-left: 15px;
        `,
        icon: {
            iconProps: {
                css: css`
                    &,
                    svg {
                        width: 9px;
                    }
                `,
            },
        },
    }),
};
wishListCardStyles.actionHideLink = {
    ...createLinkIconStyles(HideList),
};

wishListCardStyles.descriptionText = {
    size: 16,
    lineHeight: "17px",
    weight: "bold",
    css: css`
        min-height: 34px;
        ${ellipsis(2)}
    `,
};

wishListCardStyles.basicInfoGridContainer = {
    gap: 10,
    css: css`
        margin-left: 0;
    `,
};

wishListCardStyles.basicIconGridContainer = {
    gap: 0,
    css: css`
        width: fit-content;
    `,
    offsetCss: css`
        gap: 20px;
        align-items: center;
    `,
};

wishListCardStyles.starXIcon = {
    src: StarX,
    size: 15,
    color: "primary.main",
};

wishListCardStyles.itemsSmallHeading = {
    text: TRANSLATE_OBJECT as any,
};
